import React from 'react';
import { Slider, Radio, Tooltip, InputNumber, Menu, Dropdown, Icon, Button, Input } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

export default class LengthHorizontalEditor extends PropertyEditor {

    state = {
    };

    constructor(props, context) {
        super(props, context);
    }

    componentWillMount() {
        super.componentWillMount();

        const v = this.props.source.value;
        if (!v)
            this.props.source.value = { mode: "auto", actualValue: "auto" };
    }

    onPercentChange(e) {
        this.props.source.value = {
            mode: "percent",
            value: e,
            actualValue: e + "%",
        };
        this.setState({});
    }

    onPxChange(e) {
        this.props.source.value = {
            mode: "px",
            value: e,
            actualValue: e,
        };
        this.setState({});
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({});
    }

    onDropDownClick(e) {
        console.log(e);
    }

    onModeChange(e) {
        if (e === "auto") {
            this.props.source.value = {
                mode: "auto", actualValue: "auto"
            };
        }
        else if (e === "left") {
            this.props.source.value = {
                mode: "left", actualValue: "left"
            };
        }
        else if (e === "center") {
            this.props.source.value = {
                mode: "center", actualValue: "center"
            };
        }
        else if (e === "right") {
            this.props.source.value = {
                mode: "right", actualValue: "right"
            };
        }
        else if (e === "px") {
            this.props.source.value = {
                mode: "px",
                value: this.props.source.minValueAbsolute === undefined ? 0 : this.props.source.minValueAbsolute,
                actualValue: this.props.source.minValueAbsolute === undefined ? 0 : this.props.source.minValueAbsolute
            };
        }
        else {
            this.props.source.value = {
                mode: "percent",
                value: this.props.source.minValuePercent === undefined ? 0 : this.props.source.minValuePercent,
                actualValue: (this.props.source.minValuePercent === undefined ? 0 : this.props.source.minValuePercent) + '%'
            };
        }
    }

    getModeText(e) {
        if (e === "auto") {
            return "自动";
        }
        else if (e === "left") {
            return "靠左";
        }
        else if (e === "center") {
            return "居中";
        }
        else if (e === "right") {
            return "靠右";
        }
        else if (e === "px") {
            return "像素";
        }
        else {
            return "比例";
        }
    }

    render() {

        let value = this.props.source.value;
        if (!value)
            return;

        const mode = value.mode;
        value = value.value;

        const menu = (
            <Menu>
                <Menu.Item key="auto" onClick={e => this.onModeChange("auto")}>自动</Menu.Item>
                <Menu.Divider></Menu.Divider>
                <Menu.Item key="left" onClick={e => this.onModeChange("left")}>靠左</Menu.Item>
                <Menu.Item key="center" onClick={e => this.onModeChange("center")}>居中</Menu.Item>
                <Menu.Item key="right" onClick={e => this.onModeChange("right")}>靠右</Menu.Item>
                <Menu.Divider></Menu.Divider>
                <Menu.Item key="px" onClick={e => this.onModeChange("px")}>像素</Menu.Item>
                <Menu.Item key="percent" onClick={e => this.onModeChange("percent")}>比例</Menu.Item>
            </Menu>
        );

        return (
            <div className="property-editor--length">
                <div className="layout-h center hstretch">
                    {
                        mode === "auto" || mode === "left" || mode === "center" || mode === "right" ? <Input
                            className="fill"
                            disabled /> : null
                    }
                    {
                        mode === "percent" ? <InputNumber
                            className="fill"
                            value={value}
                            formatter={value => `${value}%`}
                            parser={value => value.replace('%', '')}
                            min={this.props.source.minValuePercent === undefined ? 0 : this.props.source.minValuePercent}
                            max={this.props.source.maxValuePercent === undefined ? 100 : this.props.source.maxValuePercent}
                            onChange={e => this.onPercentChange(e)} /> : null
                    }
                    {
                        mode === "px" ? <InputNumber
                            className="fill"
                            value={value}
                            min={this.props.source.minValueAbsolute === undefined ? 0 : this.props.source.minValueAbsolute}
                            max={this.props.source.maxValueAbsolute === undefined ? Number.MAX_SAFE_INTEGER : this.props.source.maxValueAbsolute}
                            onChange={e => this.onPxChange(e)} /> : null
                    }
                    <Dropdown overlay={menu} trigger={['click']}>
                        <Button
                            className='sp-left btn-bd-focus-none btn-pd-sm btn-layer-node btn-bk-hover btn-bd-none'
                            style={{ padding: '5px 5px' }}>
                            {this.getModeText(mode)} <DownOutlined type="down" style={{ marginLeft: 3, fontSize: 10 }} />
                        </Button>
                    </Dropdown>
                </div>
            </div>
        );
    }
}

PropertyGridUtils.register("length-h", (source, propertyGrid) => <LengthHorizontalEditor source={source} propertyGrid={propertyGrid} />);